
import { apiHelper } from "../apiHelper/apiHelper";
import {
  getSuppliersFailure,
  getSuppliersRequest,
  getSuppliersSuccess,
  getSupplierDetailsFailure,
  getSupplierDetailsRequest,
  getSupplierDetailsSuccess,
  deleteSupplierRequest,
  deleteSupplierSuccess,
  deleteSupplierFailure,
  getSupplierOrdersRequest,
  getSupplierOrdersSuccess,
  getSupplierOrdersFailure,
  getSupplierRatingRequest,
  getSupplierRatingSuccess,
  getSupplierRatingFailure,
} from "../slices/suppliersSlices";

// ========================== NEW API HANDLER =================

// get Farmers list
export const handleGetSuppliersList = () => async (dispatch) => {
  const endPoint = "supplier/";
  const method = "GET";
  const state1 = getSuppliersRequest;
  const state2 = getSuppliersSuccess;
  const state3 = getSuppliersFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};
// get Suppliers Orders list
export const handleGetSupplierDetails = (supplierId) => async (dispatch) => {
  const endPoint = `supplier/${supplierId}`;
  const method = "GET";
  const state1 = getSupplierDetailsRequest;
  const state2 = getSupplierDetailsSuccess;
  const state3 = getSupplierDetailsFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
 
};
 

// delete Supplier
export const handleDeleteSupplier = (supplierId) => async (dispatch) => {
  const endPoint = `supplier/${supplierId}`;  // Supplier ID is appended to the endpoint
  const method = "DELETE";  // Use DELETE method to remove the supplier
  
  const state1 = deleteSupplierRequest; // Request state action (loading)
  const state2 = deleteSupplierSuccess; // Success state action
  const state3 = deleteSupplierFailure; // Failure state action
  const isToast = false; // Toast disabled (can be enabled if you wish)
  const isFile = false; // No file upload involved
  const isToken = true; // Include authentication token

  // Call apiHelper, passing dispatch correctly
  await apiHelper(
    endPoint,
    method,
    null,  // No body required for DELETE
    state1,
    state2,
    state3,
    dispatch,  // Ensure dispatch is passed properly
    isFile,
    isToast,
    isToken
  );
};


// get Supplier Orders list
export const handleGetSupplierOrders = (supplierId) => async (dispatch) => {
  const endPoint = `order/supplier/${supplierId}`;  // Use the dynamic supplierId for the endpoint
  const method = "GET";  // Use GET method to fetch the orders
  const state1 = getSupplierOrdersRequest;
  const state2 = getSupplierOrdersSuccess;
  const state3 = getSupplierOrdersFailure;
  const isToast = false;
  const isFile = false;
  const isToken = true;

  // Call the apiHelper with the appropriate parameters
  return await apiHelper(
    endPoint,
    method,
    null,
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};


// Get Supplier Rating
export const handleGetSupplierRating = (supplierId) => async (dispatch) => {
  const endPoint = `user/get-rating/${supplierId}`; // API endpoint for fetching the supplier rating
  const method = "GET"; // Use GET method to fetch the rating
  const state1 = getSupplierRatingRequest; // Dispatch request action to indicate loading
  const state2 = getSupplierRatingSuccess; // Dispatch success action on success
  const state3 = getSupplierRatingFailure; // Dispatch failure action on error
  const isToast = false; // Disable toast notifications
  const isFile = false; // No file uploads required
  const isToken = true; // Include authentication token

  // Call the apiHelper with appropriate parameters
  return await apiHelper(
    endPoint,
    method,
    null, // No body required for GET
    state1,
    state2,
    state3,
    dispatch,
    isFile,
    isToast,
    isToken
  );
};
